var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBigIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 115,
    viewBox: "0 0 150 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.701 78.0319C124.833 73.0617 129.044 68.8576 134.022 65.7301C139.002 68.8595 143.216 73.0631 146.354 78.0319C143.22 83.0066 139.005 87.2141 134.022 90.3431C129.041 87.2152 124.83 83.0074 121.701 78.0319Z",
    fill: "url(#paint0_linear_357_111402)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.128 96.2794C114.217 92.9644 117.025 90.1606 120.346 88.0751C123.669 90.1595 126.481 92.9634 128.573 96.2794C126.48 99.5914 123.672 102.395 120.355 104.484C117.033 102.397 114.221 99.5938 112.128 96.2794Z",
    fill: "#550065"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.136 96.4941C141.392 94.506 143.079 92.825 145.072 91.5752C147.063 92.8254 148.747 94.5064 149.999 96.4941C148.747 98.4817 147.063 100.163 145.072 101.413C143.079 100.163 141.392 98.4821 140.136 96.4941Z",
    fill: "#FF004C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.728 38.9876C21.0884 43.1377 17.5524 46.6458 13.3788 49.2547C9.20611 46.6479 5.67271 43.1393 3.03906 38.9876C5.66611 34.8155 9.2 31.2873 13.3788 28.6645C17.5585 31.2894 21.095 34.8171 23.728 38.9876Z",
    fill: "#550065"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7783 23.6431C30.0237 26.4231 27.6658 28.774 24.8789 30.5221C22.0926 28.7764 19.7373 26.4249 17.9888 23.6431C19.7397 20.8607 22.0944 18.5067 24.8789 16.7548C27.6642 18.5088 30.0215 20.8623 31.7783 23.6431Z",
    fill: "url(#paint1_linear_357_111402)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27372 23.4564C7.2215 25.1276 5.80595 26.5408 4.13212 27.5913C2.46309 26.5379 1.05129 25.1251 0 23.4564C1.05164 21.7905 2.46351 20.3809 4.13212 19.3309C5.80553 20.378 7.22115 21.7881 8.27372 23.4564Z",
    fill: "#FF004C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8652 57.4057C35.7972 37.0045 53.7794 19.0223 74.1806 4.09028C94.5665 19.0379 112.545 37.0167 127.493 57.4026C112.561 77.8038 94.5786 95.786 74.1774 110.718C53.767 95.7991 35.7841 77.8162 20.8652 57.4057Z",
    fill: "#FF004C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6251 67.0561L61.673 59.1041C60.7793 58.2103 59.3355 58.2103 58.4418 59.1041C57.548 59.9978 57.548 61.4416 58.4418 62.3353L68.021 71.9145C68.9147 72.8082 70.3585 72.8082 71.2522 71.9145L95.4981 47.6687C96.3918 46.7749 96.3918 45.3312 95.4981 44.4374C94.6043 43.5437 93.1605 43.5437 92.2668 44.4374L69.6251 67.0561Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_111402",
    x1: 121.744,
    y1: 78.038,
    x2: 146.396,
    y2: 78.0446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_357_111402",
    x1: 24844.5,
    y1: 5357.54,
    x2: 24957.6,
    y2: 5470.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBigIcon);
export default __webpack_public_path__ + "static/media/checkBigIcon.c630c5c575e7f040d1e06ec888983529.svg";
export { ForwardRef as ReactComponent };